import React from 'react';
import { styles } from './ReleaseDate.css';

export type ReleaseDateProps = {
  releaseDateDisplay?: string;
  preOrderDeliveryMessage?: string;
};

export const ReleaseDate = ({ releaseDateDisplay }: ReleaseDateProps): JSX.Element => {
  const preOrderDeliveryUrl = window.Jbhifi?.preOrderDeliveryUrl;
  const preOrderDeliveryMessage = window.Jbhifi?.preOrderDeliveryMessage;

  return (
    <>
      <div className={styles.releaseDate}>
        <span>Release date</span>
        {releaseDateDisplay}
      </div>
      {preOrderDeliveryUrl && preOrderDeliveryMessage ? (
        <div className={styles.preOrderMessage}>
          <p>
            <a href={preOrderDeliveryUrl}>
              <u>{preOrderDeliveryMessage}</u>
            </a>
          </p>
        </div>
      ) : null}
    </>
  );
};

export default ReleaseDate;
